import { render, staticRenderFns } from "./IkDataTable.vue?vue&type=template&id=52c2dabe"
import script from "./IkDataTable.vue?vue&type=script&lang=js"
export * from "./IkDataTable.vue?vue&type=script&lang=js"
import style0 from "./IkDataTable.vue?vue&type=style&index=0&id=52c2dabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports